import { formatDay, formatEntryQuantity } from "./week39-view";
import type { EntryResponse } from "./useWeek39Entries";
import { productionLineFromDocument, UNMAPPED_PRODUCTION_LINE } from "./week39-production-lines";

export function selectEntryItems(items: EntryResponse["items"], line: string | undefined, date: string | null) {
  return items.filter((item) => (!date || item.date === date)
    && (!line || (productionLineFromDocument(item.documentNo) ?? UNMAPPED_PRODUCTION_LINE) === line
      || productionLineFromDocument(item.documentNo) === null));
}

function entryTime(value: string | null, productionDate: string): string {
  if (!value) return "Giriş saati bilinmiyor";
  const match = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/u.exec(value);
  if (!match) return "Giriş saati bilinmiyor";
  return match[1] === productionDate ? match[2] : `${formatDay(match[1], { day: "numeric", month: "short" })} ${match[2]}`;
}

export function EntryDayList({ items }: { items: EntryResponse["items"] }) {
  const days = [...new Set(items.map((item) => item.date))];
  return days.map((date) => {
    const dayItems = items.filter((item) => item.date === date);
    const documentNo = dayItems.every((item) => item.documentNo && item.documentNo === dayItems[0].documentNo) ? dayItems[0].documentNo : null;
    return <section className="pack39-entry-day" key={date}><h3>{formatDay(date)}<span>{dayItems.length} giriş</span></h3>
      {documentNo ? <p>Belge: {documentNo}</p> : null}
      <ol className="pack39-entry-list">{dayItems.map((item) => <li key={item.id}>
        <div><strong>{formatEntryQuantity(item.quantity, item.unit)} {item.unit ?? "birim bilinmiyor"}</strong><time>{entryTime(item.recordedAt, item.date)}</time></div>
        {!documentNo && item.documentNo ? <small>Belge: {item.documentNo}</small> : null}
        {item.batchCode || item.lotNo ? <small>{item.batchCode ? `Parti: ${item.batchCode}` : ""}{item.lotNo ? ` · Lot: ${item.lotNo}` : ""}</small> : null}
      </li>)}</ol>
    </section>;
  });
}
